import { useStripe as useStripeReact } from '@stripe/react-stripe-js';

export const useStripe = () => {
  const stripe = useStripeReact();
  return stripe;
};
